import { useEffect } from "react";
import Avatar from "react-avatar";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getSingleResolution } from "store/actions/resolutionAction";

const ChatHeader = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { singleResolution } = useSelector((state) => state.resolution);

  const handleGoBack = () => {
    history.goBack();
  };

  let DefaultAvatar_2 =
    "https://yt3.googleusercontent.com/-CFTJHU7fEWb7BYEb6Jh9gm1EpetvVGQqtof0Rbh-VQRIznYYKJxCaqv_9HeBcmJmIsp2vOO9JU=s900-c-k-c0x00ffffff-no-rj";

  return (
    <div className="d-flex bg-primary p-2 align-items-center rounded-lg ">
      <i
        role="button"
        onClick={handleGoBack}
        class="fas fa-chevron-left text-white fa-1x mr-3 ml-3"
      ></i>

      <Avatar alt="" src={DefaultAvatar_2} size="40" round />
      <div className="flex flex-col">
        <h5 className="m-0 mx-2 fs--20 fw--700 ml-3 text-white">
          {singleResolution?.name}
        </h5>
      </div>
    </div>
  );
};

export default ChatHeader;
